// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__JgFt+","ih4":"Banner_ih4__5D4Q-","ih41":"Banner_ih41__Uy4Yz"};